import { useState, useEffect, memo } from 'react'
import { Button, Table, Tag, Select, Icon } from 'mk-pc'
import { CommonStatus, useMessage } from '@mkmp/core'
import { AppSelector } from '@/components'
import { EditNav, NavFunction } from '../components'
import { queryNavList, deleteNav } from '../service'
import '../styles/main.scss'

/**
 * 导航
 */
export const NavMgmt = memo(() => {
  const [current, setCurrent] = useState<any>(null)
  const [showNavFunction, setShowNavFunction] = useState<any>(null)
  const [edit, setEdit] = useState<{ value: string; visible: boolean }>({ value: '', visible: false })
  const [searchParams, setSearchParams] = useState<{ appId?: string; status?: number; type?: number }>({ status: 1 })
  const [list, setList] = useState([] as any)

  const { messageApi, modalApi } = useMessage()

  useEffect(() => {
    fetchData()
  }, [searchParams])

  /**
   * 获取导航列表
   */
  const fetchData = async () => {
    const result = await queryNavList(searchParams)
    setList(result)
  }

  /**
   * 编辑权限
   * @param row
   */
  const handleNavFunction = (row: any) => {
    setCurrent(row)
    setShowNavFunction(true)
  }

  /**
   * 删除
   */
  const handleDelete = async (row: any) => {
    if (!row || !modalApi) return

    const confirmed = await modalApi.confirm({
      title: '删除提示',
      content: `删除导航【${row.name}】,是否继续？`
    })

    if (!confirmed) return

    await deleteNav(row.id)

    fetchData()

    messageApi.open({
      type: 'success',
      content: '删除成功'
    })
  }

  /**
   * 监听关闭
   */
  const onEditClose = (isRefresh?: boolean) => {
    setEdit((state) => ({ ...state, visible: false }))
    if (isRefresh) {
      fetchData()
    }
  }

  return (
    <section className="org-nav">
      <div className="org-nav__search">
        <div className="form">
          <AppSelector style={{ width: 160 }} value={searchParams.appId} onChange={(e: string) => setSearchParams({ ...searchParams, appId: e })} />
          <Select
            value={searchParams.status}
            placeholder="选择状态"
            style={{ width: 160 }}
            options={[
              { value: -1, label: '全部' },
              { value: 1, label: '启用' },
              { value: 0, label: '停用' }
            ]}
            onChange={(e: any) => setSearchParams({ ...searchParams, status: e })}
          />
        </div>
        <Button type="primary" onClick={() => setEdit({ value: '', visible: true })}>
          创建导航
        </Button>
      </div>
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <Table dataSource={list} scroll={{ x: 'max-content' }} pagination={false}>
          <Table.Column title="导航编码" dataIndex="code" key="code" />
          <Table.Column title="导航名称" dataIndex="name" key="name" />
          <Table.Column
            title="类型"
            dataIndex="type"
            key="type"
            width={160}
            render={(_: any, record: any) => {
              return record.type === 1 ? <Tag color="blue">模块导航</Tag> : <Tag>普通导航</Tag>
            }}
          />
          <Table.Column title="路径" dataIndex="path" key="path" width={200} />
          <Table.Column title="排序" dataIndex="order" key="order" width={80} />
          <Table.Column
            title="状态"
            dataIndex="status"
            key="status"
            width={60}
            render={(_: any, record: any) => <CommonStatus status={record.status} />}
          />
          <Table.Column
            title="操作"
            key="action"
            align="center"
            fixed="right"
            width={280}
            render={(_: any, record: any) => (
              <>
                <Button type="link" onClick={() => setEdit({ value: record.id, visible: true })}>
                  <Icon name="icon-edit" />
                  编辑
                </Button>
                <Button type="link" onClick={() => handleNavFunction(record)}>
                  <Icon name="icon-adjust" />
                  权限
                </Button>
                <Button type="link" onClick={() => handleDelete(record)}>
                  <Icon name="icon-ashbin" /> 删除
                </Button>
              </>
            )}
          />
        </Table>
      </div>
      <EditNav visible={edit.visible} value={edit.value} onClose={onEditClose} />
      <NavFunction visible={showNavFunction} current={current} onClose={() => setShowNavFunction(false)} />
    </section>
  )
})
